import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Button, Flex, Stack } from '@stepstone-genesis/components';
import { ContentHeading } from '../../../components/common/ContentHeading/index.js';
import { ArrowLeftIcon } from '@stepstone-genesis/icons';
import { useTranslation } from '@stepstone-platform/i18n';
import { useEffect } from 'react';
import { ResetPasswordButton } from './ResetPasswordButton/index.js';
import { HeaderDescription } from '../../../components/common/HeaderDescription/index.js';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.js';
import { emailSelector, resetPasswordThunk } from '../resetPasswordSlice.js';
import { validateEmail } from '../../../helpers/validateEmail.js';
import { ResetPasswordEmailInput } from './ResetPasswordEmailInput.js';
import { ResetPasswordAlert } from '../components/ResetPasswordAlert/index.js';
import { navigateToThunk } from '../../../redux/core/navigation/navigationSlice.js';
import { FORM_TYPES } from '../../../types/paramsConfig.js';
import { isBrowserSelector } from '../../../redux/core/siteConfig/siteConfigSlice.js';
import { useTrack } from '../../../tracking/common/hooks/useTrack.js';
import { activeWrapperSelector, setActiveView, } from '../../../redux/core/wrapperContext/wrapperContextSlice.js';
export const ResetPassword = () => {
    const { t } = useTranslation();
    const resetPasswordEmail = useAppSelector(emailSelector);
    const activeWrapper = useAppSelector(activeWrapperSelector);
    const dispatch = useAppDispatch();
    const isBrowser = useAppSelector(isBrowserSelector);
    const { trackBtnClick, trackModalComponentVisible } = useTrack('resetPassword');
    useEffect(() => {
        dispatch(setActiveView(FORM_TYPES.RESET_PASSWORD));
        (activeWrapper === 'modal' || activeWrapper === 'stepModal') &&
            trackModalComponentVisible();
    }, []);
    const onSendResetPassword = () => {
        if (resetPasswordEmail && validateEmail(resetPasswordEmail.value)) {
            trackBtnClick({ uniqueName: 'resetPassword' });
            dispatch(resetPasswordThunk(resetPasswordEmail.value));
            return;
        }
    };
    const onBackToLoginClick = () => {
        trackBtnClick({ uniqueName: 'backToLogin' });
        dispatch(navigateToThunk(FORM_TYPES.LOGIN));
    };
    return (_jsxs(Stack, { direction: ['vertical'], spacing: ['spaceS'], "data-testid": "reset-password", children: [_jsx(ContentHeading, { label: t('loginregistration.resetPassword.header') }), _jsx(HeaderDescription, { label: t('loginregistration.resetPassword.body') }), _jsx(ResetPasswordAlert, {}), _jsx(ResetPasswordEmailInput, {}), _jsx(ResetPasswordButton, { onClick: onSendResetPassword }), isBrowser && (_jsx(Flex, { flxJustify: 'center', children: _jsx(Button, { "data-testid": "back-to-login-button", a11yLabel: "Back to login button", variant: "link", onClick: onBackToLoginClick, isLoading: false, iconBefore: _jsx(ArrowLeftIcon, {}), children: t('loginregistration.resetPassword.linkButtonLabel') }) }))] }));
};
//# sourceMappingURL=ResetPassword.js.map